import contentLock from '@/helpers/content-lock';

const state = () => ({
    modal: null,
});

const mutations = {
    setModal(state, name) {
        state.modal = name;
        contentLock.toggle();
    },
};

export default {
    namespaced: true,
    mutations,
    state,
};
